import {useEffect} from 'react'

export const useDataInputProvider = () => {
    useEffect(() => {
        const html = document.documentElement
        const setInput = input => html.dataset.input = input
        const handleKeyDown = event => {
            if (event.key === 'Tab') setInput('keyboard')
        }
        const handlePointer = () => setInput('mouse')

        setInput('mouse')
        window.addEventListener('keydown', handleKeyDown, true)
        window.addEventListener('mousedown', handlePointer, true)
        window.addEventListener('pointerdown', handlePointer, true)
        window.addEventListener('touchstart', handlePointer, true)

        return () => {
            window.removeEventListener('keydown', handleKeyDown, true)
            window.removeEventListener('mousedown', handlePointer, true)
            window.removeEventListener('pointerdown', handlePointer, true)
            window.removeEventListener('touchstart', handlePointer, true)
            delete html.dataset.input
        }
    }, [])
}
